import { render, staticRenderFns } from "./VideoSwiper.vue?vue&type=template&id=9ff34ba0&scoped=true&"
import script from "./VideoSwiper.vue?vue&type=script&lang=js&"
export * from "./VideoSwiper.vue?vue&type=script&lang=js&"
import style0 from "./VideoSwiper.vue?vue&type=style&index=0&id=9ff34ba0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ff34ba0",
  null
  
)

export default component.exports